import { render, staticRenderFns } from "./PlatonGrid.vue?vue&type=template&id=6875f15c"
import script from "./PlatonGrid.vue?vue&type=script&lang=js"
export * from "./PlatonGrid.vue?vue&type=script&lang=js"
import style0 from "./PlatonGrid.vue?vue&type=style&index=0&id=6875f15c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports